<div class="content" showin [showDelay]="100">
    <img ngSrc="/images/home/join.png" width="100" height="100">
    <div class="texts">
        <h2>Join the Lace List</h2>
        <p>Get 10% off your first order and be the first to shop new lace drops.</p>
    </div>


    <div class="input">
        <input (keydown.enter)="join()" [(ngModel)]="email" maxlength="100">
        <button matButton="filled" (click)="join()">Join</button>
    </div>
</div>